'use client'
import React from 'react'
import { useState } from "react";
import Image from 'next/image';
import Link from 'next/link';

const WebstoriesLayout = ({ stories }: { stories: Array<any> }) => {
    // const [currentPage, setCurrentPage] = useState(1);

    const postsPerPage = 9; // posts per page
    const postsToShow = stories
        .filter((story) => story.draft === false); // add filter and query write here

    // const totalPages = Math.ceil(postsToShow.length / postsPerPage);

    // const displayedPosts = postsToShow.slice(
    //     (currentPage - 1) * postsPerPage,
    //     currentPage * postsPerPage
    // );

    // const handlePageChange = (page: number) => {
    //     setCurrentPage(page);
    // };
    return (
        <>
            <section className="mt-50 mb-50" id="blog">
                <div className="container position-relative">
                    {/* mt-n50 mt-sm-n30 mb-n50 */}
                    <div className="row gx-5">
                        {postsToShow.map((story, i) => (
                            <div
                                key={i}
                                className={`post-prev-2 col-md-6 col-lg-4`}
                            >
                                <div>
                                    <a href={`/web-stories/${story.slug}/`} style={{ textDecoration: 'none' }}>
                                        <div className="post-prev-2-img">
                                            <Image
                                                src={story.image}
                                                width={700}
                                                height={479}
                                                alt="Image Description"
                                            />
                                        </div>
                                    </a>

                                    <h3 className="post-prev-2-title !underline">
                                        <a href={`/web-stories/${story.slug}/`} style={{ textDecoration: 'none' }}>

                                            {story.page_title}
                                        </a>
                                    </h3>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Pagination */}
                    {/* <div
                        className="pagination"
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            paddingTop: '1.0rem',
                            gap: '1rem'
                        }}
                    >
                        <button
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                            className="px-4 py-2 bg-black text-white hover:bg-white hover:text-black rounded"
                        >
                            Prev
                        </button>

                        <div className='pl-4 pr-4'>
                            <span className="px-4 py-2">{currentPage} / {totalPages}</span>
                        </div>

                        <button
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className="px-4 py-2 bg-black text-white hover:bg-white hover:text-black rounded"
                        >
                            Next
                        </button>
                    </div> */}
                </div>
            </section >
        </>
    )
}

export default WebstoriesLayout